export const LogLevels = {
  DEBUG: 1,
  LOG: 2,
  INFO: 3,
  WARN: 4,
  ERROR: 5
} as const;

export type LogLevel = keyof typeof LogLevels;
